import useNonNullContext from '../../Hooks/useNonNullContext';
import { AudioPlayerContext } from './AudioPlayerContext';
import { useCallback } from 'react';
import { showNotification } from '../../helpers';
import { useHotkeys } from 'react-hotkeys-hook';

export function useAudioListPlaybackHotkeys(audioUrls: string[]) {
    const { audio, load, togglePlayPause } = useNonNullContext(AudioPlayerContext);

    const playNextAudio = useCallback(async () => {
        if (!audioUrls.length) {
            return;
        }

        const nextRowIndex = audioUrls.findIndex((url) => url === audio?.src) + 1;
        if (nextRowIndex === audioUrls.length) {
            showNotification('Last audio playing', 'info');
            return;
        }

        load({
            src: audioUrls[nextRowIndex],
            autoplay: true,
        });
    }, [audio?.src, audioUrls, load]);

    const playPrevAudio = useCallback(async () => {
        if (!audioUrls.length) {
            return;
        }

        const prevRowIndex = audioUrls.findIndex((url) => url === audio?.src) - 1;
        if (prevRowIndex < 0) {
            showNotification('First audio playing', 'info');
            return;
        }

        load({
            src: audioUrls[prevRowIndex],
            autoplay: true,
        });
    }, [audio?.src, audioUrls, load]);

    useHotkeys(
        'a',
        () => {
            playPrevAudio();
        },
        [playPrevAudio]
    );

    useHotkeys(
        's',
        () => {
            togglePlayPause();
        },
        [togglePlayPause]
    );

    useHotkeys(
        'd',
        () => {
            playNextAudio();
        },
        [playNextAudio]
    );
}
